// extracted by mini-css-extract-plugin
export default {"politik-item":"politik_politik-item__nyLgr","politik-item__title":"politik_politik-item__title__cE0zh","politik-item__text":"politik_politik-item__text__tdlDg"};